var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods-list-box"},[_c('OperationBoxComponent',{attrs:{"actions":_vm.actions,"filters":_vm.filters,"disabled":_vm.params.ids.length === 0}}),_vm._v(" "),_c('GoodsListComponent',{attrs:{"page-data":_vm.pageData},on:{"onSelectChanged":_vm.onSelectChanged,"goodsListChanged":_vm.updateGoodsList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03d9059e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/whaledge/goods/GoodsTrashPage.vue
// module id = null
// module chunks = 